import TrendingListings from './TrendingListings.provider';

export default TrendingListings;
